export default __webpack_public_path__ + "static/media/whatsapp.501cb176.svg";